import { useNavigate } from 'react-router-dom'
import backIcon from './assets/icon-back.svg'
import clearIcon from './assets/icon-clear.svg'
import { useEditNickname } from './hooks/useEditNickname'

/**
 * EditNickname 页面
 * 允许用户修改其昵称，包含输入验证、清除功能及保存逻辑。
 */
export default function EditNickname() {
  const navigate = useNavigate()
  const {
    nickname,
    setNickname,
    isLoading,
    errorMessage,
    handleSave,
    handleClear,
    canSave,
  } = useEditNickname()

  return (
    <div className='bg-white' data-testid='edit-nickname-page'>
      {/* 头部导航栏 */}
      <header className='flex h-[44px] items-center justify-between bg-white px-[20px] py-[6px]'>
        <button
          type='button'
          onClick={() => navigate(-1)}
          className='flex size-[32px] items-center justify-center'
          data-testid='back-button'
          aria-label='Go back'
        >
          <img src={backIcon} alt='' className='block size-full' />
        </button>

        <h1
          className='font-black text-[18px] leading-[28px] text-black text-center m-0'
          data-testid='page-title'
        >
          Nickname
        </h1>

        <button
          type='button'
          onClick={handleSave}
          disabled={!canSave || isLoading}
          className='font-semibold text-[16px] text-[#6e59cd] disabled:opacity-30 disabled:cursor-not-allowed px-[4px]'
          data-testid='save-button'
        >
          {isLoading ? '...' : 'Save'}
        </button>
      </header>

      {/* 主要内容区域 */}
      <main className='mt-[20px] px-[20px]'>
        {/* 输入框容器 */}
        <div className='relative flex h-[48px] items-center rounded-[12px] bg-[#f6f6f6] px-[16px]'>
          <input
            type='text'
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            placeholder='Please enter'
            disabled={isLoading}
            className='w-full border-none bg-transparent font-normal text-[14px] text-[#1a1a1a] placeholder:text-[rgba(0,0,0,0.3)] focus:outline-none disabled:opacity-60'
            data-testid='nickname-input'
            maxLength={20}
          />

          {nickname.length > 0 && !isLoading && (
            <button
              type='button'
              onClick={handleClear}
              className='ml-[8px] flex size-[14px] items-center justify-center shrink-0'
              data-testid='clear-button'
              aria-label='Clear nickname'
            >
              <img src={clearIcon} alt='' className='size-full' />
            </button>
          )}
        </div>

        {/* 错误信息展示 */}
        {errorMessage && (
          <div className='mt-[12px] px-[16px]'>
            <p
              className='text-[12px] text-[#FF3B30] leading-normal m-0'
              data-testid='error-message'
            >
              {errorMessage}
            </p>
          </div>
        )}
      </main>
    </div>
  )
}
